import { render, staticRenderFns } from "./TodoListOverview.vue?vue&type=template&id=7a4258fe&scoped=true&"
import script from "./TodoListOverview.vue?vue&type=script&lang=js&"
export * from "./TodoListOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4258fe",
  null
  
)

export default component.exports